import { Injector } from '@angular/core';
import { BaseComponent } from '../shared/baseComponent';

export class S3Connector extends BaseComponent {
  s3Files: any[] = [];
  metaFiles: any[] = [];
  glbFiles: any[] = [];
  textureFiles: any[] = [];
  groundFiles: any[] = [];
  groundHeightFiles: any[] = [];
  skyboxFiles: any[] = [];
  folders: { name: string, fileCount: number }[] = [];
  folderFiles: { [folderName: string]: any[] } = {};
  loadedFolders: { [folderName: string]: boolean } = {};
  extractFolderArray: any[] = [];

  constructor(injector: Injector) {
    super(injector);
  }

  async init(): Promise<void> {
    this.s3Files = await this.db.get('S3', 'list');
    
    // Process the files
    this.s3Files.forEach(file => {
      file.fileName = this.extractFileName(file)
    })

    this.s3Files = this.s3Files.filter((file: any) => !file.key.endsWith('/'));
    this.metaFiles = this.filterFiles(this.s3Files, "meta", 1)
    this.glbFiles = this.filterFiles(this.s3Files, "assets", 0).filter((file: any) => file.key.endsWith('.glb'));
    
    // Extract unique folder names from metaFiles and populate folders array
    const folderMap = new Map<string, any[]>();
    this.metaFiles.forEach((file: any) => {
      const folderName = this.extractNthFolderFromPath(file.key, 2); // Get folder at depth 2 (assets/meta/[folder]/)
      if (folderName) {
        if (!folderMap.has(folderName)) {
          folderMap.set(folderName, []);
        }
        folderMap.get(folderName)!.push(file);
      }
    });

    // Populate folders array and folderFiles
    this.folders = [];
    this.folderFiles = {};
    folderMap.forEach((files, folderName) => {
      this.folders.push({ name: folderName, fileCount: files.length });
      this.folderFiles[folderName] = files;
      this.loadedFolders[folderName] = true; // Mark as loaded since we have the data
    });

    this.extractFolderArray = Array.from(folderMap.keys());

    this.textureFiles = this.filterFiles(this.s3Files, "textures", 1)
    this.groundFiles = this.filterFiles(this.textureFiles, "ground", 2)
    this.groundHeightFiles = this.filterFiles(this.textureFiles, "groundheight", 2)
    this.skyboxFiles = this.filterFiles(this.textureFiles, "skyboxes", 2)
    this.textureFiles = this.textureFiles.filter((file: any) => !file.key.endsWith('/'));
    this.glbFiles = this.glbFiles.filter((file: any) => !file.key.endsWith('/'));
  }

  private extractFileName(file: any): string {
    const key = file.key as string;
    const fileTemp = key.substring(key.lastIndexOf('/') + 1);
    const fileNameWithoutExtension = fileTemp.replace(/\.[^/.]+$/, "");
    return fileNameWithoutExtension;
  }

  private filterFiles(s3Files: any[], folderName: string, nDepth: number): any[] {
    let resultArray: any = []
    s3Files.forEach(file => {
      let folderName2 = this.extractNthFolderFromPath(file.key, nDepth);
      if (folderName2 === folderName) {
        resultArray.push(file)
      }
    })
    return resultArray;
  }

  extractNthFolderFromPath(path: string, nDepth: number): string | null {
    // Extract string between slash 2 and 3 from path like "assets/meta/dev/cloud2.jpg"
    const parts = path.split('/');
    if (parts.length >= nDepth + 2) {
      return parts[nDepth]; // Returns "dev" from example
    }
    return ""
  }
}
